import { sendMessage } from "./message.service"

export const redirect = (pageUrl) => {
  sendMessage({
    action: "redirect",
    pageUrl,
  })
}

export const mountRedirect = function (url) {
  return () => redirect(url)
}
